import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import React, { useState, useEffect } from 'react';

import theme from './PermissionsPrompt.scss';


const propTypes = {
  isMobile: PropTypes.bool.isRequired,
  createFirebase: PropTypes.func.isRequired,
  isInStandaloneMode: PropTypes.bool.isRequired,
};

const NotificationPermissionsPrompt = ({ createFirebase, isInStandaloneMode, isMobile, refreshToken, organizationToken }) => {
  const [showPrompt, setShowPrompt] = useState(false);
  const [notificationPermission, setNotificationPermission] = useState(Notification.permission);

  useEffect(() => {
    if (isMobile && refreshToken && organizationToken) {
      if (notificationPermission !== 'granted') {
        setShowPrompt(true);
      }
    }
  }, [isInStandaloneMode, isMobile, notificationPermission, refreshToken, organizationToken]);

  const handleEnableNotifications = () => {
    Notification.requestPermission().then((permission) => {
      setNotificationPermission(permission);
      if (permission === 'granted') {
        createFirebase();
      }

      setShowPrompt(false);
    });
  };

  const handleClosePrompt = () => {
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className={ theme.root }>
      <div className={ theme.content }>
        <Choose>
          <When condition={ notificationPermission === 'denied' }>
            <p>
              <FormattedMessage
                id="NotificationPromt.deniedMessage"
                defaultMessage="** Notifications are disabled. Please enable notifications in your browser settings to receive call notifications when the app is in the background."
              />
            </p>
          </When>
          <Otherwise>
            <>
              <p>
                <FormattedMessage
                  id="NotificationPromt.askToAllowMessage"
                  defaultMessage="** To receive call notifications, enable notifications in your browser."
                />
              </p>
              <button onClick={ handleEnableNotifications } className={ theme.button }>
                Allow notifications
              </button>
            </>
          </Otherwise>
        </Choose>
        <button onClick={ handleClosePrompt } className={ theme.close }>
          Close
        </button>
      </div>
    </div>
  );
};

NotificationPermissionsPrompt.propTypes = propTypes;

export default NotificationPermissionsPrompt;
